// Both bar owners use the same geometry; buying and navigation remain with their owners.
window.AplovioBars = {
  measure(element) {
    const height = element.getBoundingClientRect().height;
    if (!height) return {clearance: 0, reserve: 0};
    const style = getComputedStyle(element);
    const root = getComputedStyle(document.documentElement);
    const safe = parseFloat(root.getPropertyValue('--ap-bottom-safe-area')) || 0;
    const maxSafe = parseFloat(root.getPropertyValue('--ap-bottom-safe-area-max')) || safe;
    const padding = parseFloat(style.paddingTop) || 0;
    const floating = element.dataset.placement === 'floating';
    const currentInset = floating ? safe : Math.max(padding, safe);
    const maxInset = floating ? maxSafe : Math.max(padding, maxSafe);
    const clearance = height + (parseFloat(style.bottom) || 0);
    return {
      clearance: Math.max(0, Math.round(clearance * 100) / 100),
      reserve: Math.max(0, Math.ceil(clearance - currentInset + maxInset))
    };
  }
};
